/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo, PropsWithChildren} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';

export interface SelectionHeaderButtonsProps {
  overrideClassName?: string
};

export const useStyles = makeStyles(() => ({
  selectionsActions : {
    display    : 'inline-flex',
    alignItems : 'center',
    margin     : 0,
    padding    : 0
  }
}));

/**
 * Container responsible for displaying & arranging grid header buttons.
 *
 * ```typescript
 *
 *   import {SelectionHeaderButtons} from '@ion/dls/src/grid/';
 *
 *   <SelectionHeaderButtons>
 *     <HeaderButton />
 *     <HeaderButton />
 *   </SelectionHeaderButtons>
 *
 * ```
 */
export const SelectionHeaderButtons = ({
  children,
  overrideClassName
}: PropsWithChildren<SelectionHeaderButtonsProps>) => {
  const classes = useStyles();
  return (
    <ul className={classnames(classes.selectionsActions, overrideClassName)}>
      {children}
    </ul>
  );
};

export default memo(SelectionHeaderButtons);
